import Axios from "axios";
import { headerConfig } from "../helpers/services.helper";

export const simulationService = {
  getSimulations,
  insertSimulation,
  deleteSimulation
};

async function getSimulations(page = 1) {
  return await Axios.get(
    `${process.env.VUE_APP_API_URL}/api/v1/insurances/${process.env.VUE_APP_SIMULATOR_CODE}/simulations`,
    {
      params: {
        sort: '-created_at',
        page
      },
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      withCredentials: true
    }
  );
}

async function insertSimulation(simulation) {
  const data = new FormData();
  data.append("payload", JSON.stringify(simulation));

  return await Axios.post(
    `${process.env.VUE_APP_API_URL}/api/v1/insurances/${process.env.VUE_APP_SIMULATOR_CODE}/simulations`,
    data,
    headerConfig
  );
}

async function deleteSimulation(id) {
  const conf = {
    withCredentials: true
  };
  return await Axios.delete(
    `${process.env.VUE_APP_API_URL}/api/v1/insurances/${process.env.VUE_APP_SIMULATOR_CODE}/simulations/${id}`,
    conf
  );
}
